export const DiscordIconWhite = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 71 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="DiscordIconWhite"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z"
          fill="#ffffff"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="71" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TwitterIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 410.155 410.155"
      enableBackground="new 0 0 410.155 410.155;"
      xmlSpace="preserve"
      height="25px"
      width="25px"
    >
      <path
        d="M403.632,74.18c-9.113,4.041-18.573,7.229-28.28,9.537c10.696-10.164,18.738-22.877,23.275-37.067
	l0,0c1.295-4.051-3.105-7.554-6.763-5.385l0,0c-13.504,8.01-28.05,14.019-43.235,17.862c-0.881,0.223-1.79,0.336-2.702,0.336
	c-2.766,0-5.455-1.027-7.57-2.891c-16.156-14.239-36.935-22.081-58.508-22.081c-9.335,0-18.76,1.455-28.014,4.325
	c-28.672,8.893-50.795,32.544-57.736,61.724c-2.604,10.945-3.309,21.9-2.097,32.56c0.139,1.225-0.44,2.08-0.797,2.481
	c-0.627,0.703-1.516,1.106-2.439,1.106c-0.103,0-0.209-0.005-0.314-0.015c-62.762-5.831-119.358-36.068-159.363-85.14l0,0
	c-2.04-2.503-5.952-2.196-7.578,0.593l0,0C13.677,65.565,9.537,80.937,9.537,96.579c0,23.972,9.631,46.563,26.36,63.032
	c-7.035-1.668-13.844-4.295-20.169-7.808l0,0c-3.06-1.7-6.825,0.485-6.868,3.985l0,0c-0.438,35.612,20.412,67.3,51.646,81.569
	c-0.629,0.015-1.258,0.022-1.888,0.022c-4.951,0-9.964-0.478-14.898-1.421l0,0c-3.446-0.658-6.341,2.611-5.271,5.952l0,0
	c10.138,31.651,37.39,54.981,70.002,60.278c-27.066,18.169-58.585,27.753-91.39,27.753l-10.227-0.006
	c-3.151,0-5.816,2.054-6.619,5.106c-0.791,3.006,0.666,6.177,3.353,7.74c36.966,21.513,79.131,32.883,121.955,32.883
	c37.485,0,72.549-7.439,104.219-22.109c29.033-13.449,54.689-32.674,76.255-57.141c20.09-22.792,35.8-49.103,46.692-78.201
	c10.383-27.737,15.871-57.333,15.871-85.589v-1.346c-0.001-4.537,2.051-8.806,5.631-11.712c13.585-11.03,25.415-24.014,35.16-38.591
	l0,0C411.924,77.126,407.866,72.302,403.632,74.18L403.632,74.18z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const WhitepaperIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512;"
      xmlSpace="preserve"
      width="25px"
      height="25px"
    >
      <g>
        <g>
          <g>
            <polygon
              points="320,12.499 320,127.998 435.499,127.998 			"
              fill="#ffffff"
            />
            <path
              d="M298.667,170.667c-11.776,0-21.333-9.536-21.333-21.333V0h-192C73.557,0,64,9.536,64,21.333v469.333
				C64,502.464,73.557,512,85.333,512h341.333c11.776,0,21.333-9.536,21.333-21.333v-320H298.667z M170.667,128h42.667
				c11.776,0,21.333,9.536,21.333,21.333c0,11.797-9.557,21.333-21.333,21.333h-42.667c-11.776,0-21.333-9.536-21.333-21.333
				C149.333,137.536,158.891,128,170.667,128z M341.333,384H170.667c-11.776,0-21.333-9.536-21.333-21.333
				s9.557-21.333,21.333-21.333h170.667c11.776,0,21.333,9.536,21.333,21.333S353.109,384,341.333,384z M341.333,277.333H170.667
				c-11.776,0-21.333-9.536-21.333-21.333s9.557-21.333,21.333-21.333h170.667c11.776,0,21.333,9.536,21.333,21.333
				S353.109,277.333,341.333,277.333z"
              fill="#ffffff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EtherstonesLogoLarge = () => {
  return (
    <>
      <svg
        viewBox="0 0 320 100.28612881808763"
        preserveAspectRatio="xMidYMid meet"
        id="cfadhecd"
        width="300px"
        height="100px"
      >
        <defs id="SvgjsDefs1001"></defs>
        <g
          id="SvgjsG1007"
          transform="matrix(1.0076703864899348,0,0,1.0076703864899348,0.00036847936040852963,-0.00026168941700080905)"
          fill="#fff"
        >
          <g xmlns="http://www.w3.org/2000/svg">
            <path
              fill="#fff"
              d="M98.891,31.017c-0.022-1.158-0.952-2.094-2.112-2.127l-18.492-0.527c-0.509-0.012-0.999,0.148-1.398,0.458   l-8.403,6.545l-1.024-7.76c-0.085-0.642-0.45-1.211-0.998-1.556c-0.546-0.344-1.218-0.428-1.834-0.227l-9.507,3.108L45.517,9.325   c-0.226-0.462-0.609-0.829-1.08-1.035L25.932,0.183c-0.646-0.283-1.388-0.235-1.994,0.128c-0.604,0.364-0.995,0.998-1.047,1.702   l-1.496,20.064c-0.037,0.503,0.101,1.002,0.391,1.414l21.965,31.168L24.698,79.888c-0.421,0.558-0.548,1.284-0.342,1.952   l4.983,16.149c0.185,0.601,0.62,1.09,1.194,1.346c0.281,0.124,0.582,0.188,0.883,0.188c0.313,0,0.626-0.068,0.917-0.202   l19.136-8.891c0.468-0.218,0.843-0.596,1.06-1.064l7.317-15.927l14.163,1.328c1.088,0.1,2.08-0.616,2.324-1.68l2.043-8.929   l19.99-14.965c0.562-0.421,0.886-1.085,0.872-1.787L98.891,31.017z M41.962,11.953l10.084,20.59   c0.478,0.973,1.599,1.447,2.628,1.11l6.088-1.991l-4.332,13.688c-0.29,0.918,0.058,1.918,0.855,2.457   c0.369,0.25,0.794,0.373,1.218,0.373c0.491,0,0.981-0.166,1.381-0.494l7.502-6.173c0.278-0.074,0.541-0.203,0.775-0.385   l10.782-8.397l14.512,0.413l-22.15,22.809c-0.417,0.429-0.638,1.01-0.615,1.605c0.025,0.597,0.295,1.156,0.746,1.549l3.117,2.716   c-0.105,0.183-0.19,0.377-0.236,0.587l-1.372,5.989L54.722,53.812c-0.029-0.091-0.065-0.183-0.107-0.271L38.409,19.866   c-0.387-0.805-1.225-1.289-2.118-1.226l-10.335,0.759l1.043-14.001L41.962,11.953z M28.838,81.62l18.696-24.756l3.568,0.178   l2.034,5.62c-0.168,0.135-0.321,0.293-0.445,0.478L32.394,93.145L28.838,81.62z"
            ></path>
            <path
              fill="#fff"
              d="M36.481,54.049c-0.099-0.846-0.683-1.556-1.493-1.816L13.556,45.33c-0.789-0.253-1.653-0.038-2.229,0.558   L0.611,56.968c-0.487,0.503-0.702,1.211-0.576,1.899c0.125,0.689,0.575,1.276,1.207,1.575l14.167,6.722   c0.296,0.14,0.614,0.209,0.932,0.209c0.392,0,0.782-0.105,1.126-0.314l17.981-10.897C36.177,55.72,36.581,54.894,36.481,54.049z    M13.512,49.884l14.806,4.768c-0.085,0.001-0.171-0.001-0.258,0.01L6.62,57.367c-0.16,0.021-0.311,0.063-0.458,0.116L13.512,49.884   z"
            ></path>
          </g>
        </g>
        <g
          id="SvgjsG1008"
          transform="matrix(1.297858610527258,0,0,1.297858610527258,117.89746950890758,34.510709422832555)"
          fill="#fff"
        >
          <path d="M12.08 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-7.56 0 l0 3.06 l6.68 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.46 q0 0.28 -0.2 0.49 t-0.5 0.21 l-6.68 0 l0 3.08 l7.56 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-9.76 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.76 0 z M25.34 5 q0.28 0 0.48 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.48 0.21 l-3.94 0 l0 11.14 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.3 0 -0.5 -0.21 t-0.2 -0.49 l0 -11.14 l-3.94 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -1.44 q0 -0.28 0.21 -0.49 t0.49 -0.21 l10.78 0 z M39.36 5 q0.28 0 0.48 0.21 t0.2 0.49 l0 13.28 q0 0.28 -0.2 0.49 t-0.48 0.21 l-1.52 0 q-0.28 0 -0.48 -0.21 t-0.2 -0.49 l0 -5.22 l-6.34 0 l0 5.22 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l1.5 0 q0.28 0 0.49 0.21 t0.21 0.49 l0 5.2 l6.34 0 l0 -5.2 q0 -0.28 0.2 -0.49 t0.48 -0.21 l1.52 0 z M53.739999999999995 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-7.56 0 l0 3.06 l6.68 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.46 q0 0.28 -0.2 0.49 t-0.5 0.21 l-6.68 0 l0 3.08 l7.56 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-9.76 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.76 0 z M66.28 14.02 l2.98 4.58 q0.1 0.16 0.11 0.36 t-0.08 0.36 t-0.26 0.26 t-0.35 0.1 l-1.8 0 q-0.18 0 -0.34 -0.09 t-0.24 -0.23 l-3 -4.78 l-3.54 0 l0 4.4 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l6.36 0 q2.3 0 3.73 1.31 t1.43 3.55 q0 1.44 -0.63 2.47 t-1.85 1.55 q-0.08 0.04 -0.26 0.12 z M59.75999999999999 7.82 l0 3.94 l3.9 0 q1.72 0 2.34 -0.98 q0.2 -0.36 0.2 -0.92 q0 -0.94 -0.62 -1.48 q-0.68 -0.56 -1.84 -0.56 l-3.98 0 z M81.38 12.42 q0.84 0.54 1.29 1.32 t0.45 1.74 q0 2.2 -1.7 3.42 q-1.58 1.1 -4.26 1.1 q-3.04 0 -4.7 -1.32 q-1.52 -1.22 -1.74 -3.44 q-0.04 -0.32 0.18 -0.54 t0.52 -0.22 l1.56 0 q0.28 0 0.48 0.18 t0.22 0.46 q0.04 0.52 0.27 0.89 t0.71 0.65 q0.92 0.52 2.52 0.52 q1.38 0 2.14 -0.32 q0.58 -0.26 0.78 -0.7 q0.12 -0.24 0.12 -0.62 q0 -0.24 -0.09 -0.4 t-0.29 -0.3 q-0.56 -0.38 -1.48 -0.66 q-0.8 -0.24 -2.14 -0.56 q-1.22 -0.26 -2.3 -0.7 q-1.22 -0.52 -1.92 -1.24 q-0.88 -0.88 -0.88 -2.3 q0 -1.98 1.5 -3.2 q1.46 -1.18 4.22 -1.18 t4.34 1.32 q1.48 1.22 1.58 3.14 q0.04 0.28 -0.18 0.52 q-0.24 0.2 -0.5 0.2 l-1.56 0 q-0.26 0 -0.46 -0.17 t-0.22 -0.43 q-0.06 -0.52 -0.34 -0.86 q-0.4 -0.5 -1.28 -0.74 q-0.6 -0.18 -1.53 -0.18 t-1.48 0.19 t-0.81 0.41 t-0.32 0.44 q-0.1 0.34 -0.1 0.64 q0 0.16 0.18 0.34 q0.36 0.32 0.8 0.48 q0.56 0.24 1.38 0.44 t1.71 0.42 t1.69 0.48 q0.94 0.32 1.64 0.78 z M95.58000000000001 5 q0.28 0 0.48 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.48 0.21 l-3.94 0 l0 11.14 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.3 0 -0.5 -0.21 t-0.2 -0.49 l0 -11.14 l-3.94 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -1.44 q0 -0.28 0.21 -0.49 t0.49 -0.21 l10.78 0 z M104.76 5 q3.28 0 5.38 2.2 q2.06 2.16 2.06 5.3 t-2.06 5.3 q-2.1 2.2 -5.38 2.2 t-5.38 -2.2 q-2.06 -2.16 -2.06 -5.3 t2.06 -5.3 q2.1 -2.2 5.38 -2.2 z M104.76 17.14 q2.06 0 3.32 -1.32 q1.22 -1.28 1.22 -3.31 t-1.24 -3.34 t-3.3 -1.31 t-3.3 1.31 t-1.24 3.34 t1.22 3.31 q1.26 1.32 3.32 1.32 z M126.76 5 q0.28 0 0.49 0.21 t0.21 0.49 l0 13.28 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.76 0 q-0.34 0 -0.56 -0.28 l-6.94 -9.5 l0 9.08 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l1.74 0 q0.16 0 0.32 0.07 t0.24 0.21 l6.96 9.46 l0 -9.04 q0 -0.28 0.2 -0.49 t0.48 -0.21 l1.52 0 z M141.16000000000003 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-7.56 0 l0 3.06 l6.68 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.46 q0 0.28 -0.2 0.49 t-0.5 0.21 l-6.68 0 l0 3.08 l7.56 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-9.76 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.76 0 z M153.98000000000002 12.42 q0.84 0.54 1.29 1.32 t0.45 1.74 q0 2.2 -1.7 3.42 q-1.58 1.1 -4.26 1.1 q-3.04 0 -4.7 -1.32 q-1.52 -1.22 -1.74 -3.44 q-0.04 -0.32 0.18 -0.54 t0.52 -0.22 l1.56 0 q0.28 0 0.48 0.18 t0.22 0.46 q0.04 0.52 0.27 0.89 t0.71 0.65 q0.92 0.52 2.52 0.52 q1.38 0 2.14 -0.32 q0.58 -0.26 0.78 -0.7 q0.12 -0.24 0.12 -0.62 q0 -0.24 -0.09 -0.4 t-0.29 -0.3 q-0.56 -0.38 -1.48 -0.66 q-0.8 -0.24 -2.14 -0.56 q-1.22 -0.26 -2.3 -0.7 q-1.22 -0.52 -1.92 -1.24 q-0.88 -0.88 -0.88 -2.3 q0 -1.98 1.5 -3.2 q1.46 -1.18 4.22 -1.18 t4.34 1.32 q1.48 1.22 1.58 3.14 q0.04 0.28 -0.18 0.52 q-0.24 0.2 -0.5 0.2 l-1.56 0 q-0.26 0 -0.46 -0.17 t-0.22 -0.43 q-0.06 -0.52 -0.34 -0.86 q-0.4 -0.5 -1.28 -0.74 q-0.6 -0.18 -1.53 -0.18 t-1.48 0.19 t-0.81 0.41 t-0.32 0.44 q-0.1 0.34 -0.1 0.64 q0 0.16 0.18 0.34 q0.36 0.32 0.8 0.48 q0.56 0.24 1.38 0.44 t1.71 0.42 t1.69 0.48 q0.94 0.32 1.64 0.78 z"></path>
        </g>
      </svg>
    </>
  );
};

export const EtherstonesLogoSmall = () => {
  return (
    <>
      <svg
        viewBox="0 0 320 100.28612881808763"
        preserveAspectRatio="xMidYMid meet"
        id="cfadhecd"
        width="200px"
        height="80px"
      >
        <defs id="SvgjsDefs1001"></defs>
        <g
          id="SvgjsG1007"
          transform="matrix(1.0076703864899348,0,0,1.0076703864899348,0.00036847936040852963,-0.00026168941700080905)"
          fill="#fff"
        >
          <g xmlns="http://www.w3.org/2000/svg">
            <path
              fill="#fff"
              d="M98.891,31.017c-0.022-1.158-0.952-2.094-2.112-2.127l-18.492-0.527c-0.509-0.012-0.999,0.148-1.398,0.458   l-8.403,6.545l-1.024-7.76c-0.085-0.642-0.45-1.211-0.998-1.556c-0.546-0.344-1.218-0.428-1.834-0.227l-9.507,3.108L45.517,9.325   c-0.226-0.462-0.609-0.829-1.08-1.035L25.932,0.183c-0.646-0.283-1.388-0.235-1.994,0.128c-0.604,0.364-0.995,0.998-1.047,1.702   l-1.496,20.064c-0.037,0.503,0.101,1.002,0.391,1.414l21.965,31.168L24.698,79.888c-0.421,0.558-0.548,1.284-0.342,1.952   l4.983,16.149c0.185,0.601,0.62,1.09,1.194,1.346c0.281,0.124,0.582,0.188,0.883,0.188c0.313,0,0.626-0.068,0.917-0.202   l19.136-8.891c0.468-0.218,0.843-0.596,1.06-1.064l7.317-15.927l14.163,1.328c1.088,0.1,2.08-0.616,2.324-1.68l2.043-8.929   l19.99-14.965c0.562-0.421,0.886-1.085,0.872-1.787L98.891,31.017z M41.962,11.953l10.084,20.59   c0.478,0.973,1.599,1.447,2.628,1.11l6.088-1.991l-4.332,13.688c-0.29,0.918,0.058,1.918,0.855,2.457   c0.369,0.25,0.794,0.373,1.218,0.373c0.491,0,0.981-0.166,1.381-0.494l7.502-6.173c0.278-0.074,0.541-0.203,0.775-0.385   l10.782-8.397l14.512,0.413l-22.15,22.809c-0.417,0.429-0.638,1.01-0.615,1.605c0.025,0.597,0.295,1.156,0.746,1.549l3.117,2.716   c-0.105,0.183-0.19,0.377-0.236,0.587l-1.372,5.989L54.722,53.812c-0.029-0.091-0.065-0.183-0.107-0.271L38.409,19.866   c-0.387-0.805-1.225-1.289-2.118-1.226l-10.335,0.759l1.043-14.001L41.962,11.953z M28.838,81.62l18.696-24.756l3.568,0.178   l2.034,5.62c-0.168,0.135-0.321,0.293-0.445,0.478L32.394,93.145L28.838,81.62z"
            ></path>
            <path
              fill="#fff"
              d="M36.481,54.049c-0.099-0.846-0.683-1.556-1.493-1.816L13.556,45.33c-0.789-0.253-1.653-0.038-2.229,0.558   L0.611,56.968c-0.487,0.503-0.702,1.211-0.576,1.899c0.125,0.689,0.575,1.276,1.207,1.575l14.167,6.722   c0.296,0.14,0.614,0.209,0.932,0.209c0.392,0,0.782-0.105,1.126-0.314l17.981-10.897C36.177,55.72,36.581,54.894,36.481,54.049z    M13.512,49.884l14.806,4.768c-0.085,0.001-0.171-0.001-0.258,0.01L6.62,57.367c-0.16,0.021-0.311,0.063-0.458,0.116L13.512,49.884   z"
            ></path>
          </g>
        </g>
        <g
          id="SvgjsG1008"
          transform="matrix(1.297858610527258,0,0,1.297858610527258,117.89746950890758,34.510709422832555)"
          fill="#fff"
        >
          <path d="M12.08 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-7.56 0 l0 3.06 l6.68 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.46 q0 0.28 -0.2 0.49 t-0.5 0.21 l-6.68 0 l0 3.08 l7.56 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-9.76 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.76 0 z M25.34 5 q0.28 0 0.48 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.48 0.21 l-3.94 0 l0 11.14 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.3 0 -0.5 -0.21 t-0.2 -0.49 l0 -11.14 l-3.94 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -1.44 q0 -0.28 0.21 -0.49 t0.49 -0.21 l10.78 0 z M39.36 5 q0.28 0 0.48 0.21 t0.2 0.49 l0 13.28 q0 0.28 -0.2 0.49 t-0.48 0.21 l-1.52 0 q-0.28 0 -0.48 -0.21 t-0.2 -0.49 l0 -5.22 l-6.34 0 l0 5.22 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l1.5 0 q0.28 0 0.49 0.21 t0.21 0.49 l0 5.2 l6.34 0 l0 -5.2 q0 -0.28 0.2 -0.49 t0.48 -0.21 l1.52 0 z M53.739999999999995 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-7.56 0 l0 3.06 l6.68 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.46 q0 0.28 -0.2 0.49 t-0.5 0.21 l-6.68 0 l0 3.08 l7.56 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-9.76 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.76 0 z M66.28 14.02 l2.98 4.58 q0.1 0.16 0.11 0.36 t-0.08 0.36 t-0.26 0.26 t-0.35 0.1 l-1.8 0 q-0.18 0 -0.34 -0.09 t-0.24 -0.23 l-3 -4.78 l-3.54 0 l0 4.4 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l6.36 0 q2.3 0 3.73 1.31 t1.43 3.55 q0 1.44 -0.63 2.47 t-1.85 1.55 q-0.08 0.04 -0.26 0.12 z M59.75999999999999 7.82 l0 3.94 l3.9 0 q1.72 0 2.34 -0.98 q0.2 -0.36 0.2 -0.92 q0 -0.94 -0.62 -1.48 q-0.68 -0.56 -1.84 -0.56 l-3.98 0 z M81.38 12.42 q0.84 0.54 1.29 1.32 t0.45 1.74 q0 2.2 -1.7 3.42 q-1.58 1.1 -4.26 1.1 q-3.04 0 -4.7 -1.32 q-1.52 -1.22 -1.74 -3.44 q-0.04 -0.32 0.18 -0.54 t0.52 -0.22 l1.56 0 q0.28 0 0.48 0.18 t0.22 0.46 q0.04 0.52 0.27 0.89 t0.71 0.65 q0.92 0.52 2.52 0.52 q1.38 0 2.14 -0.32 q0.58 -0.26 0.78 -0.7 q0.12 -0.24 0.12 -0.62 q0 -0.24 -0.09 -0.4 t-0.29 -0.3 q-0.56 -0.38 -1.48 -0.66 q-0.8 -0.24 -2.14 -0.56 q-1.22 -0.26 -2.3 -0.7 q-1.22 -0.52 -1.92 -1.24 q-0.88 -0.88 -0.88 -2.3 q0 -1.98 1.5 -3.2 q1.46 -1.18 4.22 -1.18 t4.34 1.32 q1.48 1.22 1.58 3.14 q0.04 0.28 -0.18 0.52 q-0.24 0.2 -0.5 0.2 l-1.56 0 q-0.26 0 -0.46 -0.17 t-0.22 -0.43 q-0.06 -0.52 -0.34 -0.86 q-0.4 -0.5 -1.28 -0.74 q-0.6 -0.18 -1.53 -0.18 t-1.48 0.19 t-0.81 0.41 t-0.32 0.44 q-0.1 0.34 -0.1 0.64 q0 0.16 0.18 0.34 q0.36 0.32 0.8 0.48 q0.56 0.24 1.38 0.44 t1.71 0.42 t1.69 0.48 q0.94 0.32 1.64 0.78 z M95.58000000000001 5 q0.28 0 0.48 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.48 0.21 l-3.94 0 l0 11.14 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.3 0 -0.5 -0.21 t-0.2 -0.49 l0 -11.14 l-3.94 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -1.44 q0 -0.28 0.21 -0.49 t0.49 -0.21 l10.78 0 z M104.76 5 q3.28 0 5.38 2.2 q2.06 2.16 2.06 5.3 t-2.06 5.3 q-2.1 2.2 -5.38 2.2 t-5.38 -2.2 q-2.06 -2.16 -2.06 -5.3 t2.06 -5.3 q2.1 -2.2 5.38 -2.2 z M104.76 17.14 q2.06 0 3.32 -1.32 q1.22 -1.28 1.22 -3.31 t-1.24 -3.34 t-3.3 -1.31 t-3.3 1.31 t-1.24 3.34 t1.22 3.31 q1.26 1.32 3.32 1.32 z M126.76 5 q0.28 0 0.49 0.21 t0.21 0.49 l0 13.28 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.76 0 q-0.34 0 -0.56 -0.28 l-6.94 -9.5 l0 9.08 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l1.74 0 q0.16 0 0.32 0.07 t0.24 0.21 l6.96 9.46 l0 -9.04 q0 -0.28 0.2 -0.49 t0.48 -0.21 l1.52 0 z M141.16000000000003 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-7.56 0 l0 3.06 l6.68 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.46 q0 0.28 -0.2 0.49 t-0.5 0.21 l-6.68 0 l0 3.08 l7.56 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-9.76 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.76 0 z M153.98000000000002 12.42 q0.84 0.54 1.29 1.32 t0.45 1.74 q0 2.2 -1.7 3.42 q-1.58 1.1 -4.26 1.1 q-3.04 0 -4.7 -1.32 q-1.52 -1.22 -1.74 -3.44 q-0.04 -0.32 0.18 -0.54 t0.52 -0.22 l1.56 0 q0.28 0 0.48 0.18 t0.22 0.46 q0.04 0.52 0.27 0.89 t0.71 0.65 q0.92 0.52 2.52 0.52 q1.38 0 2.14 -0.32 q0.58 -0.26 0.78 -0.7 q0.12 -0.24 0.12 -0.62 q0 -0.24 -0.09 -0.4 t-0.29 -0.3 q-0.56 -0.38 -1.48 -0.66 q-0.8 -0.24 -2.14 -0.56 q-1.22 -0.26 -2.3 -0.7 q-1.22 -0.52 -1.92 -1.24 q-0.88 -0.88 -0.88 -2.3 q0 -1.98 1.5 -3.2 q1.46 -1.18 4.22 -1.18 t4.34 1.32 q1.48 1.22 1.58 3.14 q0.04 0.28 -0.18 0.52 q-0.24 0.2 -0.5 0.2 l-1.56 0 q-0.26 0 -0.46 -0.17 t-0.22 -0.43 q-0.06 -0.52 -0.34 -0.86 q-0.4 -0.5 -1.28 -0.74 q-0.6 -0.18 -1.53 -0.18 t-1.48 0.19 t-0.81 0.41 t-0.32 0.44 q-0.1 0.34 -0.1 0.64 q0 0.16 0.18 0.34 q0.36 0.32 0.8 0.48 q0.56 0.24 1.38 0.44 t1.71 0.42 t1.69 0.48 q0.94 0.32 1.64 0.78 z"></path>
        </g>
      </svg>
    </>
  );
};

export const DexscreenerIcon = () => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className="bi bi-bar-chart-line-fill"
    >
      <path
        d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 
      1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const DollarSymbolIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      width="25px"
      height="25px"
    >
      <g>
        <g>
          <path
            d="M256,0C114.843,0,0,114.843,0,256s114.843,256,256,256s256-114.843,256-256S397.157,0,256,0z M265.722,242.43
     c34.571,24.766,73.756,52.836,73.756,97.049c0,40.316-28.724,74.04-66.783,81.795v18.379c0,9.223-7.473,16.696-16.696,16.696
     c-9.223,0-16.696-7.473-16.696-16.696v-18.379c-38.058-7.756-66.783-41.48-66.783-81.795c0-9.223,7.473-16.696,16.696-16.696
     s16.696,7.473,16.696,16.696c0,27.619,22.468,50.087,50.087,50.087s50.087-22.468,50.087-50.087
     c0-27.06-29.055-47.87-59.809-69.908c-34.571-24.766-73.756-52.836-73.756-97.049c0-40.316,28.724-74.04,66.783-81.795V72.348
     c0-9.223,7.473-16.696,16.696-16.696c9.223,0,16.696,7.473,16.696,16.696v18.379c38.058,7.756,66.783,41.48,66.783,81.795
     c0,9.223-7.473,16.696-16.696,16.696c-9.223,0-16.696-7.473-16.696-16.696c0-27.619-22.468-50.087-50.087-50.087
     s-50.087,22.468-50.087,50.087C205.913,199.582,234.968,220.392,265.722,242.43z"
            fill="#ffffff"
          />
        </g>
      </g>
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="25px"
      height="25px"
      viewBox="0 0 8 8"
    >
      <rect x="0.336" y="3.097" width="7.328" height="1.807" />
      <rect x="3.097" y="0.336" width="1.807" height="7.328" />
    </svg>
  );
};

export const Disclaimer = (props) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={props.w}
      height={props.h}
      viewBox="0 0 45.311 45.311"
      enableBackground="new 0 0 45.311 45.311;"
    >
      <g>
        <path
          d="M22.675,0.02c-0.006,0-0.014,0.001-0.02,0.001c-0.007,0-0.013-0.001-0.02-0.001C10.135,0.02,0,10.154,0,22.656
		c0,12.5,10.135,22.635,22.635,22.635c0.007,0,0.013,0,0.02,0c0.006,0,0.014,0,0.02,0c12.5,0,22.635-10.135,22.635-22.635
		C45.311,10.154,35.176,0.02,22.675,0.02z M22.675,38.811c-0.006,0-0.014-0.001-0.02-0.001c-0.007,0-0.013,0.001-0.02,0.001
		c-2.046,0-3.705-1.658-3.705-3.705c0-2.045,1.659-3.703,3.705-3.703c0.007,0,0.013,0,0.02,0c0.006,0,0.014,0,0.02,0
		c2.045,0,3.706,1.658,3.706,3.703C26.381,37.152,24.723,38.811,22.675,38.811z M27.988,10.578
		c-0.242,3.697-1.932,14.692-1.932,14.692c0,1.854-1.519,3.356-3.373,3.356c-0.01,0-0.02,0-0.029,0c-0.009,0-0.02,0-0.029,0
		c-1.853,0-3.372-1.504-3.372-3.356c0,0-1.689-10.995-1.931-14.692C17.202,8.727,18.62,5.29,22.626,5.29
		c0.01,0,0.02,0.001,0.029,0.001c0.009,0,0.019-0.001,0.029-0.001C26.689,5.29,28.109,8.727,27.988,10.578z"
          fill="#ffffff"
        />
      </g>
    </svg>
  );
};

export const DownArrowIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      width="50px"
      height="50px"
    >
      <path
        d="M256,0C114.618,0,0,114.618,0,256s114.618,256,256,256s256-114.618,256-256S397.382,0,256,0z M256,469.333
				c-117.818,0-213.333-95.515-213.333-213.333S138.182,42.667,256,42.667S469.333,138.182,469.333,256S373.818,469.333,256,469.333
				z"
        fill="#ffffff"
      />
      <path
        d="M347.582,198.248L256,289.83l-91.582-91.582c-8.331-8.331-21.839-8.331-30.17,0c-8.331,8.331-8.331,21.839,0,30.17
				l106.667,106.667c8.331,8.331,21.839,8.331,30.17,0l106.667-106.667c8.331-8.331,8.331-21.839,0-30.17
				C369.42,189.917,355.913,189.917,347.582,198.248z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const GemIcon = () => {
  return (
    <svg
      width="26px"
      height="26px"
      viewBox="0 -32 576 576"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const ShardIcon = () => {
  return (
    <svg
      width="28px"
      height="28px"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#ffffff"
        d="M320.94 24.86v55.654l45.31 58.49v66.27l41.24-64.038L320.94 24.86zm-56.706 16.263l-76.77 94.758 87.09 27.778 64.58-29.146-24.81-32.024-50.09-61.365zm-143.074 88.5l-82.674 96.035 82.674 26.858V129.623zm226.403 21.588l-62.307 28.122v238.334l62.176-28.875V234.5l.13-.203V151.21zm-165.907 2.436v237.258l84.912 27.766V180.73l-84.912-27.084zM44.85 247.376l76.31 102.368v-77.58l-76.31-24.79zm331.31 4.413v154.415l82.752-13.533L376.16 251.79zm73.412 161.347L376.16 425.14v46.768l73.412-58.77zm-256.267 1.238l70.93 79.78 70.738-78.973-57.516 26.713-84.152-27.52z"
      />
    </svg>
  );
};

export const TotalStonesIcon = () => {
  return (
    <svg
      version="1.1"
      id="crystal"
      x="0px"
      y="0px"
      width="26px"
      height="26px"
      viewBox="0 0 256 256"
    >
      <path
        d="M211.3,86.9l-40.5,15.7l7.5-47.8L120.6,8L62.9,54.7l13.3,84.4l-35.5-13.9l-27.8,42.1l40,80.6h133.9l29.6-59.8l26.7-52.7
   L211.3,86.9z M204,104.1l-0.3,21.9l-17.6-6.5L204,104.1z M81.1,238l-20.2-83l-14.8-17.2l31.9,13L91.8,238H81.1z M77,56.1l28.8-23.8
   l-10.5,25L77,56.1z M140.7,238l7.1-71.3l6.3-20.1L127,162.3V238h-11.3l-9.6-178.9l14.6-38.2l47.2,37.9l-13.8,87.8l21,23.2L153,238
   H140.7z M179.9,238h-8.4l42.9-107.9l-0.5-21l17.7,27L179.9,238z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const PebblesIcon = () => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#ffffff"
        d="M228.813 23L68.75 72.28 39.5 182.095l47.53-21.22 10.44-4.655 2.5 11.155 8.75 39.125 6.405 28.53-21.75-19.53-15.72-14.125-28.218 32.344 140.657 136 9.656-40.69 7.53-31.874 10.407 31.063 54.72 163.592L432.343 465.5l45.75-202.938-84.563-148.718L228.814 23zm-57.688 49.875l-27.813 39.906-3.25 73.44-27.187-88.94 58.25-24.405zm17.844 93.406l113.124 155.25L407 355.407l-107.375-.844-110.656-128v-60.28zM79.312 330.25l140.125 153.125-5.563-65.875-134.563-87.25z"
      />
    </svg>
  );
};

export const StonesIcon = () => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#ffffff"
        d="M255.875 19.5C206.14 19.5 160.037 34.86 122 61.063c33.35 9.71 66.81 10.924 98.563 4.624 23.058-19.33 50.26-33.13 81.156-41.75-14.83-2.91-30.157-4.437-45.845-4.437zm84.28 15.47c-39.835 5.745-73.35 19.004-100.78 39.874 31.776 38.663 58.146 80.623 77.063 126.937l2.125 1.064 67.906 33.812c9.494-23.477 16.547-46.637 16.124-70.47-14.33-36.806-21.36-73.78-21.375-110.75-12.902-8.085-26.644-14.965-41.064-20.467zm60.033 33.686c1.4 29.016 7.45 58.036 18.406 87.188L478 175.188c-15.394-42.552-42.668-79.38-77.813-106.532zm-294.25 6.75c-4.492 30.815-4.006 59.867 2.624 90.75l137.22 72.438c19.06-5.428 37.233-15.08 54.124-27.813-18.547-46.068-44.764-87.854-76.875-126.5-37.813 7.266-77.826 4.59-117.093-8.874zm-20.72 16.938c-38.897 40.635-63.402 95.16-65.374 155.437 12.708-9.902 24.53-20.713 35.625-32.31-.035-.084-.06-.17-.095-.25l.53-.22c12.524-13.14 24.12-27.26 34.94-42.25-6.154-27.393-7.755-53.692-5.626-80.406zm335.844 83.97c-1.416 25.13-9.332 48.69-18.75 71.342 27.002 39.79 45.036 85.1 54.188 132.72 22.526-36.18 35.53-78.914 35.53-124.72 0-20.237-2.535-39.886-7.31-58.625l-63.658-20.718zm-316.25 9c-8.685 11.924-17.89 23.38-27.687 34.28 17.71 47.887 24.35 96.876 27.625 145.72 19.492 1.947 44.6-.948 65.28-9.252 14.61-38.1 33.473-73.77 58.94-105.218l-124.157-65.53zm210.75 36.905c-20.514 16.267-43.27 28.78-67.937 35.218-25.362 29.9-44.158 64.425-58.875 102.03 25.945 16.47 49.38 35.766 66.5 60.844 53.625-28.136 118.39-54.17 174.875-69.625-9.758-33.28-24.35-64.76-43.72-93.156l-70.842-35.31zM62.688 234.812C49.61 247.83 35.511 259.882 20.22 270.78c2.602 41.27 15.764 79.64 36.843 112.44 10.402-1.57 19.94-6.687 29.187-14.22-2.964-45.772-8.778-90.685-23.563-134.188zm372.25 133.968c-56.05 15.36-121.654 41.877-174.593 70-10.558 17.43-13.517 34.648-13.938 52.814 3.145.124 6.294.187 9.47.187 75.177 0 142.078-35.016 185.31-89.655-1.577-11.25-3.65-22.378-6.248-33.344zm-258.843 4.876c-25.448 10.093-54.342 12.98-77.875 9.594-8.802 7.15-18.705 13.085-29.595 16.375 37.79 49.093 94.466 82.86 159.22 90.5.59-18.247 3.69-37.243 13.874-56.156-15.817-24.467-38.78-43.577-65.626-60.314z"
      />
    </svg>
  );
};

export const EthereumIcon = () => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 24 24"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.944 17.97L4.58 13.62 11.943 24l7.37-10.38-7.372 4.35h.003zM12.056 0L4.69 12.223l7.365 4.354 7.365-4.35L12.056 0z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const ETHSIcon = () => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M32 2C15.432 2 2 15.432 2 32s13.432 30 30 30s30-13.432 30-30S48.568 2 32 2zm10.994 44.508H21.006V17.492h21.279v5.139H26.932v6.16h14.094v5.039H26.932v7.461h16.063v5.217z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export const PeopleIcon = () => {
  return (
    <svg width="27px" height="27px" viewBox="0 0 24 24">
      <path
        fill="#ffffff"
        d="M.221 16.268a15.064 15.064 0 0 0 1.789 1.9C2.008 18.111 2 18.057 2 18a5.029 5.029 0 0 1 3.233-4.678 1 1 0 0 0 .175-1.784A2.968 2.968 0 0 1 4 9a2.988 2.988 0 0 1 5.022-2.2 5.951 5.951 0 0 1 2.022-.715 4.994 4.994 0 1 0-7.913 6.085 7.07 7.07 0 0 0-2.91 4.098zM23.779 16.268a7.07 7.07 0 0 0-2.91-4.1 4.994 4.994 0 1 0-7.913-6.086 5.949 5.949 0 0 1 2.022.715 2.993 2.993 0 1 1 3.614 4.74 1 1 0 0 0 .175 1.784A5.029 5.029 0 0 1 22 18c0 .057-.008.111-.01.167a15.065 15.065 0 0 0 1.789-1.899z"
      />
      <path
        fill="#ffffff"
        d="M18.954 20.284a7.051 7.051 0 0 0-3.085-5.114A4.956 4.956 0 0 0 17 12a5 5 0 1 0-8.869 3.17 7.051 7.051 0 0 0-3.085 5.114 14.923 14.923 0 0 0 1.968.849C7.012 21.088 7 21.046 7 21a5.031 5.031 0 0 1 3.233-4.678 1 1 0 0 0 .175-1.785A2.964 2.964 0 0 1 9 12a3 3 0 1 1 6 0 2.964 2.964 0 0 1-1.408 2.537 1 1 0 0 0 .175 1.785A5.031 5.031 0 0 1 17 21c0 .046-.012.088-.013.133a14.919 14.919 0 0 0 1.967-.849z"
      />
    </svg>
  );
};

export const LockIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="25px"
      height="25px"
      viewBox="0 0 330 330"
    >
      <path
        id="XMLID_510_"
        d="M65,330h200c8.284,0,15-6.716,15-15V145c0-8.284-6.716-15-15-15h-15V85c0-46.869-38.131-85-85-85
		S80,38.131,80,85v45H65c-8.284,0-15,6.716-15,15v170C50,323.284,56.716,330,65,330z M180,234.986V255c0,8.284-6.716,15-15,15
		s-15-6.716-15-15v-20.014c-6.068-4.565-10-11.824-10-19.986c0-13.785,11.215-25,25-25s25,11.215,25,25
		C190,223.162,186.068,230.421,180,234.986z M110,85c0-30.327,24.673-55,55-55s55,24.673,55,55v45H110V85z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const SafeIcon = () => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M0 0h24v24H0z" />
        <path
          fill="#ffffff"
          d="M18 20H6v2H4v-2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-1v2h-2v-2zm-7-6.126V17h2v-3.126A4.002 4.002 0 0 0 12 6a4 4 0 0 0-1 7.874zM12 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
        />
      </g>
    </svg>
  );
};

export const EtherstonesLogoXL = () => {
  return (
    <>
      <svg
        viewBox="0 0 320 100.28612881808763"
        preserveAspectRatio="xMidYMid meet"
        id="cfadhecd"
        width="300px"
        height="100px"
      >
        <defs id="SvgjsDefs1001"></defs>
        <g
          id="SvgjsG1007"
          transform="matrix(1.0076703864899348,0,0,1.0076703864899348,0.00036847936040852963,-0.00026168941700080905)"
          fill="#fff"
        >
          <g xmlns="http://www.w3.org/2000/svg">
            <path
              fill="#fff"
              d="M98.891,31.017c-0.022-1.158-0.952-2.094-2.112-2.127l-18.492-0.527c-0.509-0.012-0.999,0.148-1.398,0.458   l-8.403,6.545l-1.024-7.76c-0.085-0.642-0.45-1.211-0.998-1.556c-0.546-0.344-1.218-0.428-1.834-0.227l-9.507,3.108L45.517,9.325   c-0.226-0.462-0.609-0.829-1.08-1.035L25.932,0.183c-0.646-0.283-1.388-0.235-1.994,0.128c-0.604,0.364-0.995,0.998-1.047,1.702   l-1.496,20.064c-0.037,0.503,0.101,1.002,0.391,1.414l21.965,31.168L24.698,79.888c-0.421,0.558-0.548,1.284-0.342,1.952   l4.983,16.149c0.185,0.601,0.62,1.09,1.194,1.346c0.281,0.124,0.582,0.188,0.883,0.188c0.313,0,0.626-0.068,0.917-0.202   l19.136-8.891c0.468-0.218,0.843-0.596,1.06-1.064l7.317-15.927l14.163,1.328c1.088,0.1,2.08-0.616,2.324-1.68l2.043-8.929   l19.99-14.965c0.562-0.421,0.886-1.085,0.872-1.787L98.891,31.017z M41.962,11.953l10.084,20.59   c0.478,0.973,1.599,1.447,2.628,1.11l6.088-1.991l-4.332,13.688c-0.29,0.918,0.058,1.918,0.855,2.457   c0.369,0.25,0.794,0.373,1.218,0.373c0.491,0,0.981-0.166,1.381-0.494l7.502-6.173c0.278-0.074,0.541-0.203,0.775-0.385   l10.782-8.397l14.512,0.413l-22.15,22.809c-0.417,0.429-0.638,1.01-0.615,1.605c0.025,0.597,0.295,1.156,0.746,1.549l3.117,2.716   c-0.105,0.183-0.19,0.377-0.236,0.587l-1.372,5.989L54.722,53.812c-0.029-0.091-0.065-0.183-0.107-0.271L38.409,19.866   c-0.387-0.805-1.225-1.289-2.118-1.226l-10.335,0.759l1.043-14.001L41.962,11.953z M28.838,81.62l18.696-24.756l3.568,0.178   l2.034,5.62c-0.168,0.135-0.321,0.293-0.445,0.478L32.394,93.145L28.838,81.62z"
            ></path>
            <path
              fill="#fff"
              d="M36.481,54.049c-0.099-0.846-0.683-1.556-1.493-1.816L13.556,45.33c-0.789-0.253-1.653-0.038-2.229,0.558   L0.611,56.968c-0.487,0.503-0.702,1.211-0.576,1.899c0.125,0.689,0.575,1.276,1.207,1.575l14.167,6.722   c0.296,0.14,0.614,0.209,0.932,0.209c0.392,0,0.782-0.105,1.126-0.314l17.981-10.897C36.177,55.72,36.581,54.894,36.481,54.049z    M13.512,49.884l14.806,4.768c-0.085,0.001-0.171-0.001-0.258,0.01L6.62,57.367c-0.16,0.021-0.311,0.063-0.458,0.116L13.512,49.884   z"
            ></path>
          </g>
        </g>
        <g
          id="SvgjsG1008"
          transform="matrix(1.297858610527258,0,0,1.297858610527258,117.89746950890758,34.510709422832555)"
          fill="#fff"
        >
          <path d="M12.08 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-7.56 0 l0 3.06 l6.68 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.46 q0 0.28 -0.2 0.49 t-0.5 0.21 l-6.68 0 l0 3.08 l7.56 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-9.76 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.76 0 z M25.34 5 q0.28 0 0.48 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.48 0.21 l-3.94 0 l0 11.14 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.3 0 -0.5 -0.21 t-0.2 -0.49 l0 -11.14 l-3.94 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -1.44 q0 -0.28 0.21 -0.49 t0.49 -0.21 l10.78 0 z M39.36 5 q0.28 0 0.48 0.21 t0.2 0.49 l0 13.28 q0 0.28 -0.2 0.49 t-0.48 0.21 l-1.52 0 q-0.28 0 -0.48 -0.21 t-0.2 -0.49 l0 -5.22 l-6.34 0 l0 5.22 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l1.5 0 q0.28 0 0.49 0.21 t0.21 0.49 l0 5.2 l6.34 0 l0 -5.2 q0 -0.28 0.2 -0.49 t0.48 -0.21 l1.52 0 z M53.739999999999995 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-7.56 0 l0 3.06 l6.68 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.46 q0 0.28 -0.2 0.49 t-0.5 0.21 l-6.68 0 l0 3.08 l7.56 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-9.76 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.76 0 z M66.28 14.02 l2.98 4.58 q0.1 0.16 0.11 0.36 t-0.08 0.36 t-0.26 0.26 t-0.35 0.1 l-1.8 0 q-0.18 0 -0.34 -0.09 t-0.24 -0.23 l-3 -4.78 l-3.54 0 l0 4.4 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l6.36 0 q2.3 0 3.73 1.31 t1.43 3.55 q0 1.44 -0.63 2.47 t-1.85 1.55 q-0.08 0.04 -0.26 0.12 z M59.75999999999999 7.82 l0 3.94 l3.9 0 q1.72 0 2.34 -0.98 q0.2 -0.36 0.2 -0.92 q0 -0.94 -0.62 -1.48 q-0.68 -0.56 -1.84 -0.56 l-3.98 0 z M81.38 12.42 q0.84 0.54 1.29 1.32 t0.45 1.74 q0 2.2 -1.7 3.42 q-1.58 1.1 -4.26 1.1 q-3.04 0 -4.7 -1.32 q-1.52 -1.22 -1.74 -3.44 q-0.04 -0.32 0.18 -0.54 t0.52 -0.22 l1.56 0 q0.28 0 0.48 0.18 t0.22 0.46 q0.04 0.52 0.27 0.89 t0.71 0.65 q0.92 0.52 2.52 0.52 q1.38 0 2.14 -0.32 q0.58 -0.26 0.78 -0.7 q0.12 -0.24 0.12 -0.62 q0 -0.24 -0.09 -0.4 t-0.29 -0.3 q-0.56 -0.38 -1.48 -0.66 q-0.8 -0.24 -2.14 -0.56 q-1.22 -0.26 -2.3 -0.7 q-1.22 -0.52 -1.92 -1.24 q-0.88 -0.88 -0.88 -2.3 q0 -1.98 1.5 -3.2 q1.46 -1.18 4.22 -1.18 t4.34 1.32 q1.48 1.22 1.58 3.14 q0.04 0.28 -0.18 0.52 q-0.24 0.2 -0.5 0.2 l-1.56 0 q-0.26 0 -0.46 -0.17 t-0.22 -0.43 q-0.06 -0.52 -0.34 -0.86 q-0.4 -0.5 -1.28 -0.74 q-0.6 -0.18 -1.53 -0.18 t-1.48 0.19 t-0.81 0.41 t-0.32 0.44 q-0.1 0.34 -0.1 0.64 q0 0.16 0.18 0.34 q0.36 0.32 0.8 0.48 q0.56 0.24 1.38 0.44 t1.71 0.42 t1.69 0.48 q0.94 0.32 1.64 0.78 z M95.58000000000001 5 q0.28 0 0.48 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.48 0.21 l-3.94 0 l0 11.14 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.3 0 -0.5 -0.21 t-0.2 -0.49 l0 -11.14 l-3.94 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -1.44 q0 -0.28 0.21 -0.49 t0.49 -0.21 l10.78 0 z M104.76 5 q3.28 0 5.38 2.2 q2.06 2.16 2.06 5.3 t-2.06 5.3 q-2.1 2.2 -5.38 2.2 t-5.38 -2.2 q-2.06 -2.16 -2.06 -5.3 t2.06 -5.3 q2.1 -2.2 5.38 -2.2 z M104.76 17.14 q2.06 0 3.32 -1.32 q1.22 -1.28 1.22 -3.31 t-1.24 -3.34 t-3.3 -1.31 t-3.3 1.31 t-1.24 3.34 t1.22 3.31 q1.26 1.32 3.32 1.32 z M126.76 5 q0.28 0 0.49 0.21 t0.21 0.49 l0 13.28 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.76 0 q-0.34 0 -0.56 -0.28 l-6.94 -9.5 l0 9.08 q0 0.28 -0.21 0.49 t-0.49 0.21 l-1.5 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l1.74 0 q0.16 0 0.32 0.07 t0.24 0.21 l6.96 9.46 l0 -9.04 q0 -0.28 0.2 -0.49 t0.48 -0.21 l1.52 0 z M141.16000000000003 5 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-7.56 0 l0 3.06 l6.68 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.46 q0 0.28 -0.2 0.49 t-0.5 0.21 l-6.68 0 l0 3.08 l7.56 0 q0.3 0 0.5 0.21 t0.2 0.49 l0 1.44 q0 0.28 -0.2 0.49 t-0.5 0.21 l-9.76 0 q-0.28 0 -0.49 -0.21 t-0.21 -0.49 l0 -13.28 q0 -0.28 0.21 -0.49 t0.49 -0.21 l9.76 0 z M153.98000000000002 12.42 q0.84 0.54 1.29 1.32 t0.45 1.74 q0 2.2 -1.7 3.42 q-1.58 1.1 -4.26 1.1 q-3.04 0 -4.7 -1.32 q-1.52 -1.22 -1.74 -3.44 q-0.04 -0.32 0.18 -0.54 t0.52 -0.22 l1.56 0 q0.28 0 0.48 0.18 t0.22 0.46 q0.04 0.52 0.27 0.89 t0.71 0.65 q0.92 0.52 2.52 0.52 q1.38 0 2.14 -0.32 q0.58 -0.26 0.78 -0.7 q0.12 -0.24 0.12 -0.62 q0 -0.24 -0.09 -0.4 t-0.29 -0.3 q-0.56 -0.38 -1.48 -0.66 q-0.8 -0.24 -2.14 -0.56 q-1.22 -0.26 -2.3 -0.7 q-1.22 -0.52 -1.92 -1.24 q-0.88 -0.88 -0.88 -2.3 q0 -1.98 1.5 -3.2 q1.46 -1.18 4.22 -1.18 t4.34 1.32 q1.48 1.22 1.58 3.14 q0.04 0.28 -0.18 0.52 q-0.24 0.2 -0.5 0.2 l-1.56 0 q-0.26 0 -0.46 -0.17 t-0.22 -0.43 q-0.06 -0.52 -0.34 -0.86 q-0.4 -0.5 -1.28 -0.74 q-0.6 -0.18 -1.53 -0.18 t-1.48 0.19 t-0.81 0.41 t-0.32 0.44 q-0.1 0.34 -0.1 0.64 q0 0.16 0.18 0.34 q0.36 0.32 0.8 0.48 q0.56 0.24 1.38 0.44 t1.71 0.42 t1.69 0.48 q0.94 0.32 1.64 0.78 z"></path>
        </g>
      </svg>
    </>
  );
};

export const DownArrowIcon1 = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 490 490"
      enableBackground="new 0 0 490 490"
      width="25px"
      height="25px"
    >
      <path
        d="M52.8,311.3c-12.8-12.8-12.8-33.4,0-46.2c6.4-6.4,14.7-9.6,23.1-9.6s16.7,3.2,23.1,9.6l113.4,113.4V32.7
		c0-18,14.6-32.7,32.7-32.7c18,0,32.7,14.6,32.7,32.7v345.8L391,265.1c12.8-12.8,33.4-12.8,46.2,0c12.8,12.8,12.8,33.4,0,46.2
		L268.1,480.4c-6.1,6.1-14.4,9.6-23.1,9.6c-8.7,0-17-3.4-23.1-9.6L52.8,311.3z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const RefreshIcon = () => {
  return (
<svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 492.883 492.883" width="25px" height="25px">
	<g>
		<path d="M122.941,374.241c-20.1-18.1-34.6-39.8-44.1-63.1c-25.2-61.8-13.4-135.3,35.8-186l45.4,45.4c2.5,2.5,7,0.7,7.6-3
			l24.8-162.3c0.4-2.7-1.9-5-4.6-4.6l-162.4,24.8c-3.7,0.6-5.5,5.1-3,7.6l45.5,45.5c-75.1,76.8-87.9,192-38.6,282
			c14.8,27.1,35.3,51.9,61.4,72.7c44.4,35.3,99,52.2,153.2,51.1l10.2-66.7C207.441,421.641,159.441,407.241,122.941,374.241z"/>
		<path d="M424.941,414.341c75.1-76.8,87.9-192,38.6-282c-14.8-27.1-35.3-51.9-61.4-72.7c-44.4-35.3-99-52.2-153.2-51.1l-10.2,66.7
			c46.6-4,94.7,10.4,131.2,43.4c20.1,18.1,34.6,39.8,44.1,63.1c25.2,61.8,13.4,135.3-35.8,186l-45.4-45.4c-2.5-2.5-7-0.7-7.6,3
			l-24.8,162.3c-0.4,2.7,1.9,5,4.6,4.6l162.4-24.8c3.7-0.6,5.4-5.1,3-7.6L424.941,414.341z"/>
	</g>
</svg>
  )
}

export const MoneyUpIcon = () => {
  return (
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 407.747 407.747" width="25px" height="25px" fill="#ffffff">
	<path d="M229.559,186.253c-8.321-0.667-16.477,1.008-23.717,4.761l-30.512-35.829c2.72-0.77,5.584-1.062,8.488-0.833
		c6.401,0.514,12.22,3.488,16.384,8.378c3.579,4.205,9.893,4.71,14.097,1.13c4.205-3.58,4.711-9.892,1.13-14.097
		c-7.627-8.957-18.286-14.407-30.013-15.347c-8.331-0.672-16.483,1.005-23.72,4.759l-4.484-5.266
		c-3.582-4.205-9.892-4.711-14.097-1.13s-4.711,9.893-1.13,14.097l4.495,5.277c-11.887,16.09-11.628,38.852,1.887,54.721
		c7.627,8.957,18.286,14.407,30.013,15.347c8.329,0.67,16.481-1.006,23.718-4.759l30.513,35.829c-2.718,0.769-5.58,1.06-8.488,0.831
		c-6.402-0.514-12.221-3.488-16.385-8.378c-3.581-4.205-9.893-4.711-14.097-1.13c-4.205,3.581-4.711,9.893-1.13,14.097
		c7.628,8.957,18.287,14.407,30.014,15.347c1.201,0.097,2.397,0.145,3.59,0.145c7.072,0,13.938-1.688,20.132-4.899l4.482,5.263
		c1.979,2.323,4.789,3.517,7.618,3.517c2.292,0,4.597-0.784,6.479-2.387c4.205-3.581,4.711-9.893,1.13-14.097l-4.486-5.268
		c4.857-6.547,7.809-14.33,8.477-22.658c0.939-11.727-2.743-23.117-10.371-32.073C251.944,192.642,241.285,187.192,229.559,186.253z
		 M179.976,202.286c-6.401-0.514-12.22-3.488-16.384-8.378c-6.283-7.377-7.316-17.482-3.48-25.745l28.351,33.291
		C185.742,202.224,182.878,202.516,179.976,202.286z M219.474,207.021c2.721-0.77,5.584-1.062,8.487-0.833
		c6.402,0.514,12.221,3.488,16.385,8.378s6.175,11.107,5.662,17.509c-0.233,2.904-0.977,5.686-2.172,8.25L219.474,207.021z"/>
	<path d="M316.342,108.537c-52.769-61.961-146.109-69.44-208.074-16.673c-30.016,25.563-48.28,61.284-51.43,100.584
		c-3.148,39.3,9.195,77.474,34.758,107.489c25.563,30.017,61.283,48.281,100.584,51.431c4.024,0.322,8.035,0.482,12.029,0.482
		c35.002,0,68.519-12.296,95.46-35.24C361.632,263.841,369.111,170.5,316.342,108.537z M280.218,293.77
		c-23.916,20.367-54.329,30.206-85.643,27.693c-31.312-2.509-59.772-17.062-80.14-40.978c-20.367-23.915-30.202-54.33-27.693-85.643
		c2.509-31.312,17.062-59.772,40.977-80.14c22.096-18.817,49.189-28.017,76.163-28.017c33.292,0,66.394,14.028,89.62,41.301
		C335.546,177.357,329.587,251.726,280.218,293.77z"/>
	<path d="M369.41,85.104l12.509,3.634c5.302,1.54,10.852-1.51,12.393-6.814c1.54-5.304-1.511-10.852-6.814-12.393l-42-12.199
		c-3.023-0.876-6.279-0.282-8.794,1.606c-2.515,1.89-3.995,4.852-3.995,7.997v46.199c0,5.522,4.478,10,10,10s10-4.478,10-10v-17.01
		c55.961,76.876,44.049,185.445-29.521,248.1c-29.297,24.949-64.974,39.888-103.172,43.199c-5.503,0.478-9.576,5.324-9.1,10.826
		c0.452,5.209,4.819,9.138,9.951,9.138c0.29,0,0.582-0.013,0.875-0.038c42.367-3.673,81.93-20.236,114.412-47.898
		C417.493,290.181,430.85,170.298,369.41,85.104z"/>
	<path d="M185.572,387.187c-47.468-4.767-90.649-27.4-121.591-63.732c-41.11-48.272-54.412-113.291-35.585-173.926
		c1.638-5.274-1.31-10.878-6.584-12.516c-5.276-1.637-10.878,1.311-12.516,6.584c-20.873,67.22-6.122,139.304,39.458,192.824
		c34.308,40.284,82.187,65.38,134.819,70.666c0.34,0.034,0.677,0.051,1.011,0.051c5.073,0,9.421-3.847,9.938-9.002
		C195.075,392.641,191.067,387.739,185.572,387.187z"/>
	<path d="M28.417,121.25c1.505,0.808,3.125,1.191,4.722,1.191c3.564,0,7.015-1.911,8.819-5.271c2.86-5.327,6.022-10.569,9.396-15.58
		c3.086-4.581,1.873-10.795-2.708-13.88c-4.581-3.086-10.795-1.874-13.88,2.708c-3.745,5.561-7.254,11.378-10.43,17.291
		C21.725,112.574,23.551,118.636,28.417,121.25z"/>
	<path d="M78.272,66.636c2.292,0,4.597-0.784,6.479-2.387c35.486-30.22,80.659-45.748,127.193-43.714
		c5.512,0.251,10.185-4.036,10.426-9.555c0.241-5.518-4.037-10.186-9.555-10.426C161.227-1.696,111.128,15.516,71.784,49.023
		c-4.205,3.581-4.711,9.893-1.13,14.097C72.633,65.443,75.443,66.636,78.272,66.636z"/>
    </svg>
  )
}
